import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function exportToExcel({ filename, sheetName = "Sayfa1", columns, rows }) {
    // columns: [{ header, key }]  rows: [ {key: value, ...} ]
    const headerRow = columns.map((c) => c.header);
    const data = rows.map((r) => columns.map((c) => r[c.key] ?? ""));
    const aoa = [headerRow, ...data];

    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!cols"] = columns.map((c) => ({ wch: Math.max(c.header.length + 2, c.width || 18) }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${filename}.xlsx`);
}

export function exportToPdf({ filename, title, columns, rows, orientation = "landscape" }) {
    const doc = new jsPDF({ orientation, unit: "pt", format: "a4" });
    if (title) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(title, 40, 40);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.setTextColor(120);
        doc.text(new Date().toLocaleString("tr-TR"), 40, 58);
        doc.setTextColor(0);
    }

    autoTable(doc, {
        startY: title ? 76 : 40,
        head: [columns.map((c) => c.header)],
        body: rows.map((r) => columns.map((c) => (r[c.key] ?? "").toString())),
        theme: "striped",
        styles: { fontSize: 9, cellPadding: 5, overflow: "linebreak" },
        headStyles: { fillColor: [217, 4, 41], textColor: 255, fontStyle: "bold" },
        alternateRowStyles: { fillColor: [248, 249, 250] },
        margin: { left: 40, right: 40 },
    });

    doc.save(`${filename}.pdf`);
}
